<template>
    <span :endTime="endTime" :callback="callback" :endText="endText">
        <slot>
            {{content}}
        </slot>
    </span>
</template>
<script>
  export default {
    data () {
      return {
        content: '',
        timer: ''
      }
    },
    props: {
      endTime: {
        type: String,
        default: ''
      },
      endText: {
        type: String,
        default: '已结束'
      },
      callback: {
        type: Function
      }
    },
    mounted () {
      this.countdown(this.endTime)
    },
    destroyed () {
      clearInterval(this.timer);
      sessionStorage.removeItem("byl_exam_seconds")
    },
    methods: {
      countdown (seconds) {
        let self = this;
        var endTime;
        if (sessionStorage.getItem("byl_exam_seconds") && sessionStorage.getItem("byl_exam_seconds") > 0) {
          endTime = sessionStorage.getItem("byl_exam_seconds")
        } else {
          endTime = parseInt(seconds)
        }
        this.timer = setInterval(function () {
          endTime--
          sessionStorage.setItem("byl_exam_seconds", endTime);
          if (endTime>0) {
            let hour=Math.floor(endTime/3600);
            let min=Math.floor((endTime/60)%60);
            let sec=Math.floor(endTime%60);
            hour = hour < 10 ? "0" + hour : hour;
            min = min < 10 ? "0" + min : min;
            sec = sec < 10 ? "0" + sec : sec;
            let format = '';
            if (hour > 0) {
              format = `${hour}小时${min}分${sec}秒`;
            }
            if (hour <= 0) {
              format =`${min}分${sec}秒`;
            }
            self.content = format;
          } else {
            clearInterval(this.timer);
            self.content = self.endText;
            self._callback();
          }
        }, 1000);
      },
      _callback () {
        if (this.callback && this.callback instanceof Function) {
          this.callback(...this);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/countDown/countDown.vue